<template>
  <table
    ref="table"
    class="table">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in headColumns"
          :key="idx"
          :style="col.style"
        >
          <span>
            {{ col.text }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, idx) in rows"
        :key="idx"
        :ref="`tr-${idx}`"
        @click="toggle(`tr-${idx}`)"
      >
        <td
          v-for="(item, itemIdx) in row"
          :key="itemIdx"
        >
          <div class="head">
            <span>
              <i
                v-if="itemIdx === 0"
                class="fas fa-angle-right"
              />
              {{ item.head.text }}
            </span>
          </div>
          <div class="body">
            <p
              v-for="(body, bodyIndex) in item.body"
              :key="bodyIndex"
              :class="`tr-${idx}-p-${bodyIndex} limit-line`"
              @mouseover="handleMouseover(`tr-${idx}-p-${bodyIndex}`)"
              @mouseleave="handleMouseleave(`tr-${idx}-p-${bodyIndex}`)"
            >
              {{ body.text }}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'BaseTableCollapse',

  props: ['headColumns', 'rows'],

  methods: {
    toggle (ref) {
      this.$refs[ref][0].classList.toggle('active')
    },
    handleMouseover (className) {
      const elements = this.$refs.table.querySelectorAll(`.${className}`)
      elements.forEach((ele) => {
        ele.classList.add('bg-light')
      })
    },
    handleMouseleave (className) {
      const elements = this.$refs.table.querySelectorAll(`.${className}`)
      elements.forEach((ele) => {
        ele.classList.remove('bg-light')
      })
    },
  },
}
</script>

<style scoped>
tr th, tr td {
  padding-left: 0;
  padding-right: 0;
}

tr span, tr p {
  padding-left: 10px;
  padding-right: 10px;
}

tbody tr {
  cursor: pointer;
}

tr .body {
  display: none;
  margin-top: 6px;
  margin-bottom: 2px;
}

tr td:first-of-type .body p {
  padding-left: 24px;
}

tr .body p {
  padding-top: 2px;
  padding-bottom: 2px;
  margin: 0;
  height: 25px;
  /* max-width: 600px; */
}

tr .head i {
  margin-right: 2px;
}

tr.active .body {
  display: block;
}

tr.active .head i {
  transform: rotate(90deg);
}

.bg-light {
  background-color: tan;
}

.limit-line {
  display: inline-block;
  width: 99.99%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseTableCollapse.vue